module.exports = __webpack_public_path__ + "img/shopware_logo_blue.130832fe.svg";